import { render } from "./ProdutoResumido.vue?vue&type=template&id=0f089bb4&scoped=true"
import script from "./ProdutoResumido.vue?vue&type=script&lang=js"
export * from "./ProdutoResumido.vue?vue&type=script&lang=js"

import "./ProdutoResumido.vue?vue&type=style&index=0&id=0f089bb4&lang=scss"
import "./ProdutoResumido.vue?vue&type=style&index=1&id=0f089bb4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f089bb4"]])

export default __exports__